class Filters extends Immutable.Record({
    filters: Immutable.OrderedMap()
}) {

}

class Filter extends Immutable.Record({
    ModuleConfigGridFilter: {
        id: 0,
        module_item_id: 0,
        field: '',
        label: '',
        filter_values: null,
        is_hidden: 0,
        order: 0,
        type: '',
        settings: {},
        plugin: '',
        alias: ''
    }
}) {
    isHidden() {
        var v = this.get('ModuleConfigGridFilter').get('is_hidden');
        if (typeof(v) == 'boolean') {
            return v;
        }
        return !!parseInt(v)
    }
}

// Reviver, used with Immutable.fromJS().
// https://facebook.github.io/immutable-js/docs/#/fromJS
// https://github.com/facebook/immutable-js/issues/57#issuecomment-77529149
function FiltersFromJS(key, value) {
    var isIndexed = Immutable.Iterable.isIndexed(value);
    if (isIndexed) {
        if (value.getIn([0, 'ModuleConfigGridFilter', 'id'], null) !== null) {
            return value.toKeyedSeq().mapKeys((_, v) => v.getIn(['ModuleConfigGridFilter', 'id'])).toOrderedMap()
        }
        return value.toList();
    }

    // associative
    if (value.get('ModuleConfigGridFilter', null) !== null) {
        return new Filter({
            ModuleConfigGridFilter: value.get('ModuleConfigGridFilter')
        });
    }
    return value.toMap();
}